// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1R9ml","footer":"ModalCreateQualiphyProcedure_footer__1OkVz","additionData":"ModalCreateQualiphyProcedure_additionData__KORh5"};